import { render, staticRenderFns } from "./dashHeader.vue?vue&type=template&id=143bc342"
import script from "./dashHeader.vue?vue&type=script&lang=js"
export * from "./dashHeader.vue?vue&type=script&lang=js"
import style0 from "./dashHeader.vue?vue&type=style&index=0&id=143bc342&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports